import React from 'react';
export var FinectIsoPlus = function FinectIsoPlus(_ref) {
  var color = _ref.color,
    size = _ref.size;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 7 38 46",
    width: size || '40',
    fill: color || 'none'
  }, React.createElement("g", null, React.createElement("path", {
    d: "M10.457 37.4105L25.6237 51.87V38.8098L17.313 30.9043L10.457 37.4105Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M25.6237 9.90279L10.457 24.3503L17.313 30.9043L25.6237 22.963V9.90279Z",
    fill: "white",
    fillOpacity: "0.5"
  }), React.createElement("path", {
    d: "M10.457 37.4105L17.313 30.9043L10.457 24.3503V37.4105Z",
    fill: "white",
    fillOpacity: "0.25"
  }), React.createElement("path", {
    d: "M28.1993 31.4665H20.9141L21.9276 30.3422H29.2247L28.1993 31.4665Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M25.6237 34.0378V26.6945L24.5029 27.723V35.0664L25.6237 34.0378Z",
    fill: "white"
  })));
};